import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../Store';
import { redirectActions } from "../../actions/RedirectAction";

function RedirectRoute() {
    const redirectState = useSelector((state: RootState) => state.redirectState);
    const dispatch = useDispatch();
    const { path } = redirectState!;

    useEffect(() => {
        if (path) {
            dispatch(redirectActions.redirectDone());
            window.location = '/';
        }
    // eslint-disable-next-line
    }, [path])

    return (<></>)
}

export default RedirectRoute